import { ErrorHandler, Injectable, inject } from '@angular/core';
import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { AppInsightsService } from './app-insights.service';

@Injectable()
export class ErrorHandlerService extends ErrorHandler {
  private appInsightService = inject(AppInsightsService);

  handleError(error: Error) {
    const ignoreErrors = ['Error retrieving icon :tops!', 'ResizeObserver loop limit exceeded'];
    if (!ignoreErrors.find((errorText) => error.message?.startsWith(errorText))) {
      this.appInsightService.logException(error, SeverityLevel.Error); // Manually log exception
    }
    super.handleError(error);
  }
}
